



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SNSShareButtonsComponent extends Vue {
  @Prop() msg!: string;
  @Prop() tags!: string[];
  url = location.href;
}
